import { ENVS } from '@/constants';

export const doc2html = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append('file', file);
  return fetch(`${ENVS.VITE_DOCUMENT_URL}/document/doc2html`, {
    method: 'POST',
    mode: 'cors',
    body: formData
  })
    .then(async (res) => {
      return res.json();
    })
    .then((res) => {
      if (res.success) {
        return res?.data?.html;
      } else {
        throw new Error(res?.message);
      }
    });
};
export const html2pdf = async (html: string, fileName: string): Promise<File> => {
  return fetch(`${ENVS.VITE_DOCUMENT_URL}/document/html2pdf-pw`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json' // 设置内容类型
    },
    body: JSON.stringify({ html })
  }).then(async (res) => {
    const blob = await res.blob();
    return new File([blob], fileName + '.pdf', { type: 'application/pdf' });
  });
};
